import { AccountShippingAddress } from './models'
import { ApiError } from '../api-error-data'
import { axiosInstance } from '../../../api'
import { ENDPOINTS } from '../endpoints'

const { AUTH: { ACCOUNT_ME_ADDRESS_SHIPPING } } = ENDPOINTS

export type SaveAddressType = {
  isValidated: boolean
  isAddressChanged: boolean
} & AccountShippingAddress

export const accountApi = {
  async getShippingAsync(): Promise<AccountShippingAddress> {
    try {
      const response =  await axiosInstance.get(ACCOUNT_ME_ADDRESS_SHIPPING)
      return response.data as AccountShippingAddress
    } catch (error) {
      throw new ApiError(error)
    }
  },

  async setShippingAsync(
    request: Omit<AccountShippingAddress, 'isValidated'>
  ): Promise<any> {

      const response = await axiosInstance.put(ACCOUNT_ME_ADDRESS_SHIPPING, {
        ...request,
      })
      return response
  }
}
